import { render, staticRenderFns } from "./SigleSelect.vue?vue&type=template&id=a08927fa"
import script from "./SigleSelect.vue?vue&type=script&lang=js"
export * from "./SigleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports